webpackJsonp([3],{

/***/ 0:
/*!**********************************************!*\
  !*** ./src/pages/user-manage/user-manage.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(/*! ../../assets/lib/boostrap/css/bootstrap.css */ 5);
	
	__webpack_require__(/*! ../../assets/lib/boostrap/js/bootstrap */ 4);
	
	__webpack_require__(/*! ../../assets/lib/fontawesome/css/font-awesome.min.css */ 6);
	
	__webpack_require__(/*! ./user-manage.less */ 41);
	
	var _validation = __webpack_require__(/*! ../../assets/js/validation */ 31);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	var _main = __webpack_require__(/*! ../../assets/js/main */ 3);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _util = __webpack_require__(/*! ../../assets/js/util */ 2);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _bootbox = __webpack_require__(/*! ../../assets/lib/bootbox/bootbox */ 9);
	
	var _bootbox2 = _interopRequireDefault(_bootbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Jason on 2017-4-17.
	 */
	;
	//弹窗
	
	
	_main2.default.ready(function (userData) {
	    var $userManageList = $('#user-manage-list');
	    var companyId = _util2.default.getCompanyId();
	    var userTypeMap = ['', '负责人', '联系人', '查看人'];
	    $.get(("https://api.custom.orancrab.com") + '/companyUser/queryUserList', {
	        'companyId': companyId
	    }, function (json) {
	        if (json.status == 0) {
	            var html = '';
	            json.data.forEach(function (user) {
	                html += renderTr(user);
	            });
	            $userManageList.html(html);
	        } else {
	            location = '/index.html';
	        }
	    });
	    function renderTr(user) {
	        return '<tr><td>' + user.name + '</td><td>' + user.phone + '</td><td>' + userTypeMap[user.userType] + '</td>\n            <td>' + (user.userType == 3 ? '<button data-id="' + user.relationId + '" type="button" data-type="del" class="btn btn-xs btn-danger">\u5220\u9664</button>' : '-') + '</td></tr>';
	    }
	    var $addUser = _bootbox2.default.dialog({
	        keep: true,
	        title: '增加查看人',
	        message: '<form class="form-horizontal add-user-box">\n            <div class="form-group">\n            <label for="company-name" class="col-sm-2 control-label"><span class="require">*</span>\u59D3\u540D</label>\n            <div class="col-sm-6">\n            <input type="text" maxlength="6" name="name" class="name form-control" placeholder="2-6\u4E2A\u4E2D\u6587">\n            </div>\n            <div class="col-sm-4 form-error"></div></div>\n            <div class="form-group">\n            <label for="company-name" class="col-sm-2 control-label"><span class="require">*</span>\u624B\u673A</label>\n             <div class="col-sm-6">\n            <input type="text" maxlength="11" name="phone" class="phone form-control" placeholder="11\u4F4D\u624B\u673A\u53F7">\n            </div>\n            <div class="col-sm-4 form-error"></div></div>\n        </form>',
	        show: false,
	        closeButton: false,
	        buttons: {
	            'no': {
	                label: '取消',
	                className: 'btn-danger'
	            },
	            'ok': {
	                label: '提交',
	                className: 'btn-success',
	                callback: function callback() {
	                    valid.validAll(function (status) {
	                        $.post(("https://api.custom.orancrab.com") + '/companyUser/addCompanyUser', {
	                            companyId: companyId,
	                            userName: status.name.value,
	                            userPhone: status.phone.value
	                        }, function (json) {
	                            if (json.status == 0) {
	                                _util2.default.success('新增成功');
	                                $addUser.modal('hide');
	                                $userManageList.append(renderTr(json.data));
	                            }
	                        });
	                    });
	                    return false;
	                }
	            }
	        }
	    });
	    //验证
	    var valid = new _validation2.default($addUser.find('.add-user-box'), {
	        methods: {
	            'name': function name(value, result) {
	                if (_util2.default.isName(value)) {
	                    result(true);
	                } else {
	                    result('请填写2-6个中文姓名');
	                }
	            },
	            'phone': function phone(value, result) {
	                if (_util2.default.isPhone(value)) {
	                    result(true);
	                } else {
	                    result('请填写11位数字的手机号');
	                }
	            }
	        }
	    });
	    //弹窗打开
	    $("#add-view-user").on('click', function () {
	        valid.empty();
	        $addUser.modal('show');
	    });
	    //删除
	    $userManageList.on('click', function (e) {
	        var $t = $(e.target);
	        if ($t.data('type') == 'del') {
	            _util2.default.confirm('确定要删除吗？', function () {
	                $.post(("https://api.custom.orancrab.com") + '/companyUser/removeCompanyUser', {
	                    companyId: companyId,
	                    relationId: $t.data('id')
	                }, function (json) {
	                    if (json.status == 0) {
	                        $t.closest('tr').remove();
	                    }
	                });
	            });
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 1)))

/***/ }),

/***/ 31:
/*!*************************************!*\
  !*** ./src/assets/js/validation.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by Jason on 2016/12/8.
	 * 基于jq，bootstrap
	 * todo 注意js操作的input修改值的时候请手动触发change事件 $hidden.trigger('change');
	 * todo 可以手动在input上选择触发验证的事件类型，比如 <input data-valid-event='change' />，你会发现模拟组件有这个很好用
	 * options: {
	 *      methods: {
	 *          'name': function (value, result) { 
	 *              result(errorStr|true|null, str|array); //null表示不验证，第二个可选参数，指定结果应用到哪些name，默认只有当前name
	 *          } 
	 *      },
	 *      //验证变化的input或者select，textarea
	 *      change: function(obj) {} obj = {name: {value:value, result: result}} ; result可以是true和字符串
	 * }
	 */
	(function () {
	    'use strict';
	
	    var Validation = function Validation(el, options) {
	        var self = this;
	        var $el = $(el).eq(0);
	        self.options = options;
	        self.status = {};
	        //DOM关联
	        self._initDom($el);
	        //初始化验证
	        self._initValid();
	    };
	
	    Validation.prototype = {
	        /**
	         * 初始化dom
	         * @param $el
	         * @private
	         */
	        _initDom: function _initDom($el) {
	            var self = this;
	            var $inputs = $el.find('[name]');
	            var methods = self.options.methods;
	            var i, $item;
	            var $errorDom = {};
	            var $controlDom = {};
	            var name;
	            var $formGroup;
	            for (i = $inputs.length; i--;) {
	                $item = $inputs.eq(i);
	                name = $item.attr('name');
	                //输入框dom
	                if ($controlDom[name]) {
	                    $controlDom[name] = $controlDom[name].add($item);
	                } else {
	                    $controlDom[name] = $item;
	                }
	                if (!methods[name]) {
	                    continue;
	                }
	                //错误dom
	                if (!$errorDom[name]) {
	                    $formGroup = $item.closest('.form-group');
	                    $errorDom[name] = {
	                        'form-group': $formGroup,
	                        'form-error': $formGroup.find('.form-error').addClass('fa')
	                    };
	                }
	            }
	            self.$errorDom = $errorDom;
	            self.$controlDom = $controlDom;
	        },
	        /**
	         * 初始化事件，初始化值
	         * @private
	         */
	        _initValid: function _initValid() {
	            var self = this;
	            var $controlDom = self.$controlDom;
	            var methods = self.options.methods;
	            var status = self.status;
	            var name;
	            var $input, type, event;
	            for (name in $controlDom) {
	                $input = $controlDom[name];
	                type = $input.eq(0).attr('type');
	                //获取值
	                status[name] = {
	                    value: getValue($input)
	                };
	                if (!methods[name]) {
	                    continue;
	                }
	                //绑定事件
	                event = $input.data('valid-event');
	                if (event) {
	                    $input.on(event, handler);
	                    continue;
	                }
	                switch ($input.attr('type')) {
	                    case 'radio':
	                        $input.on('change', function (e) {
	                            if ($(e.target).prop('checked')) {
	                                handler(e);
	                            }
	                        });
	                        break;
	                    case 'hidden':
	                    case 'checkbox':
	                        $input.on('change', handler);
	                        break;
	                    default:
	                        if ($input.prop('tagName') === 'run') {
	                            $input.on('change', handler);
	                        } else {
	                            $input.on('blur', handler);
	                        }
	                }
	            }
	            /**
	             * 事件回调
	             * @param e
	             */
	            function handler(e) {
	                var $t = $(e.target);
	                var name = $t.attr('name');
	                var value = getValue($controlDom[name]);
	                if (status[name].result && status[name].value === value) {
	                    return;
	                }
	                status[name].value = value;
	                methods[name](value, function (result, extraName) {
	                    self._resultEvent(name, extraName, result);
	                }, status);
	            }
	        },
	        /**
	         * 触发多个验证
	         * @param names
	         * @param callback
	         */
	        _validNames: function _validNames(names, callback) {
	            var self = this;
	            var methods = self.options.methods;
	            var $controlDom = self.$controlDom;
	            var status = self.status;
	            var i, name;
	            var len = names.length;
	            var dfd;
	            var dfdArr = [];
	            var dfdCache = self.dfdCache = {};
	            var cacheVaues = {};
	            for (i = 0; i < len; i++) {
	                name = names[i];
	                if (!methods[name]) {
	                    continue;
	                }
	                cacheVaues[name] = status[name].value;
	                status[name].value = getValue($controlDom[name]);
	            }
	            for (i = 0; i < len; i++) {
	                name = names[i];
	                if (!methods[name]) {
	                    continue;
	                }
	                if (status[name].value === cacheVaues[name] && status[name].result != null) {
	                    return;
	                }
	                dfd = $.Deferred();
	                dfdCache[name] = dfd;
	                methods[name](status[name].value, function (name) {
	                    return function (result, extraName) {
	                        self._resultEvent(name, extraName, result, true);
	                    };
	                }(name), status);
	                dfdArr.push(dfd);
	            }
	            $.when.apply($, dfdArr).then(function () {
	                callback(status);
	            });
	        },
	        /**
	         * 事件结果处理
	         * @private
	         */
	        _resultEvent: function _resultEvent(name, extraName, result, isDfd) {
	            var self = this;
	            var i, len, item;
	            self._result(name, result, isDfd);
	            if ((typeof extraName === 'undefined' ? 'undefined' : _typeof(extraName)) === 'object') {
	                for (i = 0, len = extraName.length; i < len; i++) {
	                    item = extraName[i];
	                    if (item === name) {
	                        continue;
	                    }
	                    self._result(item, result, isDfd);
	                }
	            } else if (typeof extraName === 'string') {
	                self._result(extraName, result, isDfd);
	            }
	        },
	        /**
	         * 处理单个验证结果
	         * @param name
	         * @param result
	         * @param isDfd
	         * @private
	         */
	        _result: function _result(name, result, isDfd) {
	            var self = this;
	            var status = self.status;
	            var $validDom = self.$errorDom[name];
	            var dfdCache = self.dfdCache;
	            if (!$validDom) {
	                return;
	            }
	            status[name].result = result;
	            if (typeof result === 'string') {
	                $validDom['form-group'].removeClass('has-success').addClass('has-error');
	                $validDom['form-error'].html(result).addClass('fa-exclamation-circle').removeClass('fa-check-circle');
	            } else if (result === true) {
	                $validDom['form-group'].removeClass('has-error').addClass('has-success');
	                $validDom['form-error'].html('').addClass('fa-check-circle').removeClass('fa-exclamation-circle');
	                isDfd && dfdCache[name].resolve();
	            } else {
	                $validDom['form-group'].removeClass('has-error').removeClass('has-success');
	                $validDom['form-error'].html('').removeClass('fa-check-circle').removeClass('fa-exclamation-circle');
	                isDfd && dfdCache[name].resolve();
	            }
	            self.options.change && self.options.change(name, status);
	        },
	        /**
	         * 验证某个值是否成功
	         * 返回 true | str | null。 null时表示未验证
	         */
	        getResult: function getResult(name) {
	            var status = this.status[name];
	            if (!status) {
	                return null;
	            }
	            return status.result;
	        },
	        /**
	         * 全部验证结果，如果成功则调用success
	         */
	        validAll: function validAll(success) {
	            var self = this;
	            var name;
	            var validNames = [];
	            var result;
	            for (name in self.status) {
	                result = self.status[name].result;
	                if (typeof result === 'string') {
	                    return;
	                }
	                if (result === true) {
	                    continue;
	                }
	                validNames.push(name);
	            }
	            if (validNames.length) {
	                self._validNames(validNames, success);
	            } else {
	                success(self.status);
	            }
	        },
	        /**
	         * 初始化，清空
	         */
	        empty: function empty() {
	            var self = this;
	            var $controlDom = self.$controlDom;
	            var $errorDom = self.$errorDom;
	            var status = self.status;
	            var name;
	            for (name in $controlDom) {
	                $controlDom[name].val('');
	                status[name] = {};
	                if ($errorDom[name]) {
	                    $errorDom[name]['form-group'].removeClass('has-error').removeClass('has-success');
	                }
	            }
	        },
	        /**
	         * 设置值
	         * @param values
	         */
	        setValues: function setValues(values) {
	            var self = this;
	            var $controlDom = self.$controlDom;
	            var $errorDom = self.$errorDom;
	            var status = self.status;
	            var name;
	            var value;
	            for (name in values) {
	                if ($controlDom[name]) {
	                    value = values[name] === undefined ? '' : values[name];
	                    $controlDom[name].val(value);
	                    status[name] = { value: value };
	                }
	                if ($errorDom[name]) {
	                    $errorDom[name]['form-group'].removeClass('has-error').removeClass('has-success');
	                }
	            }
	        }
	    };
	
	    /**
	     * 按照name获取值
	     * @param $input
	     * @returns {*}
	     */
	    function _getValue($input) {
	        var value, type;
	        if ($input.length === 1) {
	            type = $input.prop('type');
	            if ((type === 'radio' || type === 'checkbox') && !$input.prop('checked') || $input.prop('disabled')) {
	                return '';
	            }
	            return $.trim($input.val());
	        } else {
	            value = [];
	            $input.each(function (index, item) {
	                var val = getValue($(item));
	                if (val) {
	                    value.push(val);
	                }
	            });
	            return value;
	        }
	    }
	
	    /**
	     * 获取值，判断值类型
	     * @param $input
	     * @returns {*}
	     */
	    function getValue($input) {
	        var value = _getValue($input);
	        if (/\[\]$/.test($input.eq(0).attr('name'))) {
	            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
	                value = [value];
	            }
	        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	            value = value[0] || '';
	        }
	        return value;
	    }
	
	    /**
	     * export
	     */
	    if (true) {
	        module.exports = Validation;
	    } else {
	        window.Validation = Validation;
	    }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 1)))

/***/ }),

/***/ 41:
/*!************************************************!*\
  !*** ./src/pages/user-manage/user-manage.less ***!
  \************************************************/
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/user-manage.js